import { toast } from 'react-toastify';

import { ToastNotification } from '@/components';
import { DEFAULT_TOAST_ERROR_MESSAGE, DEFAULT_TOAST_ERROR_TITLE } from '@/constants';

export const showServerErrorToast = () =>
  toast.error(
    <ToastNotification type="error" title={DEFAULT_TOAST_ERROR_TITLE} message={DEFAULT_TOAST_ERROR_MESSAGE} />,
  );
